import { useRef, useEffect } from "react";
import JsBarcode from "jsbarcode";
import styles from "./BarcodeLabel.module.css";

export default function BarcodeLabel({ barcode, description, lotNumber, expiryDate }) {
  const svgRef = useRef(null);

  useEffect(() => {
    if (svgRef.current && barcode) {
      JsBarcode(svgRef.current, barcode, {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: true,
        fontSize: 12,
        margin: 4,
        background: "#ffffff",
        lineColor: "#000000",
      });
    }
  }, [barcode]);

  return (
    <div className={styles.label}>
      <svg ref={svgRef} className={styles.barcodeSvg} />
      <div className={styles.info}>
        <div className={styles.description}>{description}</div>
        {lotNumber && <div className={styles.meta}>Lot: {lotNumber}</div>}
        {expiryDate && <div className={styles.meta}>Exp: {expiryDate}</div>}
      </div>
    </div>
  );
}
